import { useState } from "react";
import {
  Box,
  CssBaseline,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  useTheme,
  useMediaQuery,
  Avatar,
  Typography,
  AppBar,
  IconButton,
  MenuItem,
  Menu,
} from "@mui/material";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import "../../styles/components.css";
import logo from "../../styles/images/footerLogo.png";
import pointer from "../../styles/images/menu.svg";
import avtivePointer from "../../styles/images/activePointer.svg";
import CustomDialog from "../dialog";
import { localStorageInstance } from "../../utils/storage";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";

const drawerWidth = 254;
const collapsedDrawerWidth = 65;

const NavigationBar = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [logout, setLogout] = useState(false);
  const userName = localStorageInstance.getItem("user");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const location = useLocation();
  const [auth, setAuth] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEl1, setAnchorEl1] = useState(null);
  const handleChange = (event) => {
    setAuth(event.target.checked);
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleProfile = (event) => {
    setAnchorEl1(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseProfile = () => {
    setAnchorEl1(null);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  const menuItems = [
    { text: "Joined Leagues", path: "/joined_leagues" },
    { text: "Leagues", path: "/my_leagues" },
  ];

  const drawer = (
    <div>
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <div className="d-flex flex-row margin-auto mt-2_5 align-items-center">
          <img src={logo} alt="logo" style={{ width: "64px" }} />
          <p className="logo-text">Fantrade</p>
        </div>
      </Toolbar>

      <List sx={{ marginLeft: "13px", marginRight: "13px" }}>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding className="mt-3">
            <ListItemButton
              onClick={() => navigate(item.path)}
              selected={location.pathname === item.path}
              className={`nav-list-item ${location.pathname === item.path ? "nav-list-item-selected" : ""}`}
            >
              <ListItemIcon
                className={`nav-list-item-icon ${isCollapsed ? "nav-list-item-icon-collapsed" : ""}`}
              >
                {location.pathname === item.path ? (
                  <img src={pointer} alt="pointer" style={{ width: "38px" }} />
                ) : (
                  <img
                    src={avtivePointer}
                    alt="pointer"
                    style={{ width: "38px" }}
                  />
                )}
              </ListItemIcon>
              {!isCollapsed && <ListItemText primary={item.text} />}
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <div className="toolbar_profile">
        <Avatar className="toolbar_profile_avatar">
          {`${userName?.split(" ")[0].charAt(0)}${userName?.split(" ")[1] ? userName?.split(" ")[1].charAt(0) : ""}`}
        </Avatar>
        <div className="toolbar_profile_name">
          <p className="toolbar_profile_name_text">{userName}</p>
          <p
            className="toolbar_profile_logout_text"
            onClick={() => setLogout(true)}
          >
            Logout
          </p>
        </div>
      </div>
    </div>
  );

  const currentDrawerWidth = isCollapsed ? collapsedDrawerWidth : drawerWidth;

  return (
    <>
      {isMobile ? <Box sx={{ flexGrow: 1 }} className={"mobile_navbar"}>
        <AppBar position="static">
          <Toolbar>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 2 }}
              onClick={handleMenu}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Photos
            </Typography>
            <div>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleProfile}
                color="inherit"
              >
                <Avatar>
                  {`${userName?.split(" ")[0].charAt(0)}${userName?.split(" ")[1] ? userName?.split(" ")[1].charAt(0) : ""}`}
                </Avatar>
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                slotProps={{
                  paper: {
                    elevation: 0,
                    sx: {
                      overflow: "visible",
                      filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                      mt: 1.5,
                      "& .MuiAvatar-root": {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                      },
                      "&::before": {
                        content: '""',
                        display: "block",
                        position: "absolute",
                        top: 0,
                        left: 14,
                        width: 10,
                        height: 10,
                        bgcolor: "background.paper",
                        transform: "translateY(-50%) rotate(45deg)",
                        zIndex: 0,
                      },
                    },
                  },
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                {menuItems.map((item) => (
                  <ListItem
                    key={item.text}
                    disablePadding
                    className="navbar_list"
                  >
                    <ListItemButton
                      onClick={() => navigate(item.path)}
                      selected={location.pathname === item.path}
                      className={`nav-list-item ${location.pathname === item.path ? "nav-list-item-selected" : ""}`}
                    >
                      <ListItemIcon
                        className={`nav-list-item-icon ${isCollapsed ? "nav-list-item-icon-collapsed" : ""}`}
                      >
                        {location.pathname === item.path ? (
                          <img
                            src={pointer}
                            alt="pointer"
                            style={{ width: "38px" }}
                          />
                        ) : (
                          <img
                            src={avtivePointer}
                            alt="pointer"
                            style={{ width: "38px" }}
                          />
                        )}
                      </ListItemIcon>
                      {!isCollapsed && <ListItemText primary={item.text} />}
                    </ListItemButton>
                  </ListItem>
                ))}
              </Menu>

              <Menu
                id="menu-appbar"
                anchorEl={anchorEl1}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                slotProps={{
                  paper: {
                    elevation: 0,
                    sx: {
                      overflow: "visible",
                      filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                      mt: 1.5,
                      "& .MuiAvatar-root": {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                      },
                      "&::before": {
                        content: '""',
                        display: "block",
                        position: "absolute",
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: "background.paper",
                        transform: "translateY(-50%) rotate(45deg)",
                        zIndex: 0,
                      },
                    },
                  },
                }}
                open={Boolean(anchorEl1)}
                onClose={handleCloseProfile}
              >
                <MenuItem>
                  {userName}
                </MenuItem>
                <MenuItem onClick={handleLogout}>Logout</MenuItem>
              </Menu>
            </div>
          </Toolbar>
        </AppBar>
        <Box p={2}>
          <Outlet />
        </Box>
      </Box> :
        <Box sx={{ display: "flex" }} className={"desktop_navbar"}>
          <CustomDialog
            open={logout}
            handleClose={() => setLogout(false)}
            handleSubmit={handleLogout}
            buttonTxt="Logout"
            title="Confirmation: Log Out"
            cancelBtn={true}
            alignActions={"center"}
            fullWidth={true}
          >
            <Typography className="align_text_center mb-2">
              Are you sure you want to log out?
            </Typography>
          </CustomDialog>
          <CssBaseline />
          <Box
            component="nav"
            sx={{ width: { sm: currentDrawerWidth }, flexShrink: { sm: 0 } }}
          >
            {isMobile ? (
              <Drawer
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{
                  keepMounted: true,
                }}
                sx={{
                  display: { xs: "block", sm: "none" },
                  "& .MuiDrawer-paper": {
                    boxSizing: "border-box",
                    width: currentDrawerWidth,
                  },
                }}
              >
                {drawer}
              </Drawer>
            ) : (
              <Drawer
                variant="permanent"
                sx={{
                  display: { xs: "none", sm: "block" },
                  "& .MuiDrawer-paper": {
                    boxSizing: "border-box",
                    width: currentDrawerWidth,
                    backgroundColor: "#D2D2E5",
                  },
                }}
                open
              >
                {drawer}
              </Drawer>
            )}
          </Box>
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              p: 3,
              width: { sm: `calc(100% - ${currentDrawerWidth}px)` },
            }}
          >
            <Outlet />
          </Box>
        </Box>}

    </>
  );
};

export default NavigationBar;
